import styled from "styled-components";

export const SelectContainer = styled.div`
  position: relative;
  width: 100%;
  display: inline-block;
  font-size: 1.4rem;
  color: #888;

  &::after {
    content: "";
    border-width: 5px;
    border-style: solid;
    border-color: transparent;
    border-top-color: var(--color);
    display: inline-block;
    border-radius: 2px;
    position: absolute;
    right: 10px;
    bottom: 30%;
  }
`;

export const Select = styled.select`
  display: block;
  width: 100%;
  min-height: 40px;
  border-radius: 3px;
  border: none;
  color: var(--color);
  background: var(--background-color);
  border-bottom: 2px solid #f3f3f3;
  outline: none;
  padding: 0 20px 0 10px;
  margin-top: 5px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  font-family: "GothamLight", Arial, Helvetica, sans-serif;

  -ms-appearance: none;
`;

export const Option = styled.option`
  background: #fff;
  color: #000;
  font-family: "GothamLight", Arial, Helvetica, sans-serif; ;
`;

export const ErrorMenssage = styled.p`
  color: #f00;
`;
